export const emptyRoom = (campaigns) => ({
    [`camp-${campaigns[0].id}`]: {
        id: campaigns[0].id,
        name: campaigns[0].title,
        pic: campaigns[0].thumbnails && campaigns[0].thumbnails.medium || campaigns[0].image,
        nextPic: campaigns[1].thumbnails && campaigns[1].thumbnails.small || campaigns[1].image,
        uid: campaigns[0].author_id
    },
    [`camp-${campaigns[1].id}`]: {
        id: campaigns[1].id,
        name: campaigns[1].title,
        pic: campaigns[1].thumbnails && campaigns[1].thumbnails.medium || campaigns[1].image,
        nextPic: campaigns[0].thumbnails && campaigns[0].thumbnails.small || campaigns[0].image,
        uid: campaigns[1].author_id
    },
    campaigns: [
        campaigns[0].id + '_' + campaigns[1].id,
        campaigns[1].id + '_' + campaigns[0].id,
        campaigns[0].id,
        campaigns[1].id
    ],
    users: [
        campaigns[0].author_id + '_' + campaigns[1].author_id,
        campaigns[1].author_id + '_' + campaigns[0].author_id,
        campaigns[0].author_id,
        campaigns[1].author_id
    ],
    created_date: new Date(),
    lastMessageDate: new Date().getTime(),
    lastMessage: {
        message: null,
        seen: null,
        uid: null
    }
})

export const emptyShopRoom = (shops, shopsIds) => ({
    [`shop-${shops[0].id}`]: {
        id: shops[0].id,
        name: shops[0].title,
        pic: shops[0].logo,
        nextPic: shops[1].logo,
        uid: shops[0].owner_id
    },
    [`shop-${shops[1].id}`]: {
        id: shops[1].id,
        name: shops[1].title,
        pic: shops[1].logo,
        nextPic: shops[0].logo,
        uid: shops[1].owner_id
    },
    shops: [
        shops[0].id + '_' + shops[1].id,
        shops[1].id + '_' + shops[0].id,
        shops[0].id,
        shops[1].id
    ],
    users: [
        shops[0].owner_id + '_' + shops[1].owner_id,
        shops[1].owner_id + '_' + shops[0].owner_id,
        shops[0].owner_id,
        shops[1].owner_id
    ],
    created_date: new Date(),
    lastMessageDate: new Date().getTime(),
    lastMessage: {
        message: null,
        seen: null,
        uid: null
    },
    isShop: true,
    requestReceiverShopId: shopsIds[0],
    requestSenderShopId: shopsIds[1]
})